import type { ToolResult } from "@/types/tools";

const escapedCharacters: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

const namedEntities: Record<string, string> = {
  amp: "&",
  lt: "<",
  gt: ">",
  quot: '"',
  apos: "'",
  nbsp: "\u00a0",
};

export function escapeHtml(input: string) {
  return input.replace(/[&<>"']/g, (character) => escapedCharacters[character]);
}

export function unescapeHtml(input: string): ToolResult<string> {
  try {
    return {
      ok: true,
      value: input.replace(/&(#[xX][0-9a-fA-F]+|#\d+|[a-zA-Z]+);/g, (entity, body: string) => {
        if (body.startsWith("#x") || body.startsWith("#X")) {
          return decodeCodePoint(entity, Number.parseInt(body.slice(2), 16));
        }

        if (body.startsWith("#")) {
          return decodeCodePoint(entity, Number.parseInt(body.slice(1), 10));
        }

        return namedEntities[body.toLowerCase()] ?? entity;
      }),
    };
  } catch {
    return { ok: false, error: "Unable to decode one or more HTML entities." };
  }
}

function decodeCodePoint(fallback: string, codePoint: number) {
  if (!Number.isInteger(codePoint) || codePoint < 0 || codePoint > 0x10ffff) {
    return fallback;
  }

  try {
    return String.fromCodePoint(codePoint);
  } catch {
    return fallback;
  }
}
